import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { LEASING } from '../../../types';
import { LoanFormLayout } from '../shared/LoanFormLayout';
import { useIsLoanFormDisabled } from '../shared/useIsLoanFormDisabled';
import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';
import { FormDateInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDateInput';
import { FormPercentInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormPercentInput';
import { FormTextInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormTextInput';

type Props = {
    index: number;
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
};

export const LoanForm: React.FC<Props> = ({ applicant, index }) => {
    const { t } = useTranslation();
    const disabled = useIsLoanFormDisabled({ applicant, commandName: LOAN_REQUEST_COMMANDS.changeLiabilityLeasing });
    const { control } = useFormContext<SchemaCreditRequestForm>();
    const name = `${LEASING}.${index}` as const;

    return (
        <LoanFormLayout
            name={name}
            disabled={disabled}
            left={
                <>
                    <FormCurrencyInput
                        control={control}
                        id={`${name}.rateMonatlich`}
                        label={t('EXISTING_LOANS.LOAN_MONTHLY_RATE')}
                        disabled={disabled}
                    />
                    <FormCurrencyInput
                        control={control}
                        id={`${name}.schlussrate`}
                        label={t('EXISTING_LOANS.LOAN_FINAL_RATE')}
                        disabled={disabled}
                    />
                    <FormDateInput
                        control={control}
                        id={`${name}.datumLetzteRate`}
                        label={t('EXISTING_LOANS.LOAN_LAST_RATE_DATE')}
                        disabled={disabled}
                    />
                    <FormPercentInput
                        control={control}
                        id={`${name}.zinssatz`}
                        label={t('EXISTING_LOANS.LOAN_INTEREST')}
                        allowDecimals
                        disabled={disabled}
                    />
                </>
            }
            right={
                <FormTextInput
                    control={control}
                    id={`${name}.glaeubiger`}
                    label={t('EXISTING_LOANS.LOAN_CREDITOR')}
                    disabled={disabled}
                />
            }
        />
    );
};
